import { get } from "react-hook-form";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { getWorkOrders } from "../repositorie/WorkOrdersRepositorie";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchData = ({ setIsLoading, setError }: Props) => {
	const {
		state: { dataToGetWorkOrders },
		actions: { setRows, setRowData, setNoResults, setColumns },
	} = useWorkOrdersContext();

	return async () => {
		setRows([]);
		setIsLoading(true);
		if (dataToGetWorkOrders.AssetId || dataToGetWorkOrders.AssetId === 0) {
			const res = await getWorkOrders(dataToGetWorkOrders);
			if (res.ok) {
				const dataColumns = get(res, "data.tables[0].columns", null);
				const dataRows = get(res, "data.tables[0].rows", null);
				const rowsSource = get(res, "data.tables[0].rows", null);
				if (rowsSource.length) {
					rowsSource.forEach((row: any) => {
						row.id = row.WorkOrderId;
						row.close = row.WorkOrderStatusCode === "O";
					});
					setRowData(dataRows);
					setColumns(dataColumns);
					setRows(rowsSource);
				} else {
					setRowData([]);
					setNoResults(true);
				}
			} else {
				setError(res.message);
			}
		}
		setIsLoading(false);
	};
};
